import { useState } from "react";
import { FormattedMessage } from "react-intl";
import LoadOutCheckbox from "../../components/fragments/loadOutCheckbox";
import ThreeModalActions from "../../components/fragments/threeModalActions";
import {
  DisplayBlock,
  TableLineResponsive,
  TableLineResponsiveHeader,
} from "../../styles/common";
import { formatDate } from "../../utils/utils";
import {
  AddressContainer,
  AddressLine,
  CodeContainer,
  DevicesLineResponsiveContainer,
} from "./style";

export default function ListItem({
  listData,
  updateData,
  deleteData,
  setModalObject,
  setAddEditRegister,
  setIdEditRegister,
  setCheckID,
}) {
  const [lineActionsDropdown, setLineActionsDropdown] = useState(false);

  function handleOnChange() {
    setCheckID(listData.id, !listData.active);
  }

  return (
    <>
      <TableLineResponsive>
        <TableLineResponsiveHeader>
          <AddressLine>
            <LoadOutCheckbox
              value={listData.active}
              onChange={handleOnChange}
            />
            <AddressContainer>
              <DisplayBlock>
                <h5>{listData.name}</h5>
              </DisplayBlock>
            </AddressContainer>
          </AddressLine>
          <ThreeModalActions
            openModal={lineActionsDropdown}
            setOpenModal={setLineActionsDropdown}
            editAction={async () => {
              setAddEditRegister(true);
              setIdEditRegister(listData.id);
              setLineActionsDropdown(false);
              await updateData(listData.id)
            }}
            deleteAction={() => {
              setLineActionsDropdown(false);
              setModalObject({
                type: "alert",
                buttonLabel: "Delete",
                open: true,
                title: "Confirm delete",
                desc: "Are you sure you want to delete this item?",
                action: async () =>
                  await deleteData(listData.id)
              });
            }}
          />
        </TableLineResponsiveHeader>
        <DevicesLineResponsiveContainer>
          <CodeContainer>
            <h6>
              <FormattedMessage id="tabela.members" />
            </h6>
            <p>{JSON.parse(listData.contactids).length + ' members'}</p>
          </CodeContainer>
        </DevicesLineResponsiveContainer>
      </TableLineResponsive>
      <tr>
        <td>
          <LoadOutCheckbox
            value={listData.active}
            onChange={handleOnChange}
            label={listData.name}
          />
        </td>
        <td>
          <span>{JSON.parse(listData.contactids).length + ' members'}</span>
        </td>
        <td>
          <span>{formatDate(listData.createdat)}</span>
        </td>
        <td className="d-flex justify-content-end align-items-center">
          <ThreeModalActions
            openModal={lineActionsDropdown}
            setOpenModal={setLineActionsDropdown}
            editAction={async () => {
              setAddEditRegister(true);
              setIdEditRegister(listData.id);
              setLineActionsDropdown(false);
              await updateData(listData.id);
            }}
            deleteAction={() => {
              setLineActionsDropdown(false);
              setModalObject({
                type: "alert",
                buttonLabel: "Delete",
                open: true,
                title: "Confirm delete",
                desc: "Are you sure you want to delete this item?",
                action: async () => await deleteData(listData.id),
              });
            }}
          />
        </td>
      </tr>
    </>
  );
}
